import { SystemConnection } from '@Types';
import { SensorConfigFormShape } from '@Types/configurations.types';
import { PayloadPeekMethods } from './peekEnclosingHelper';
import { TimeRange } from './timeRange';
import { DbHelpers } from './db-driver-helpers';

export class SensorConnectPeek {
	private systemConnection?: SystemConnection;

	public withSystemConnection(con: SystemConnection) {
		this.systemConnection = con;
		return this;
	}

	protected useSystemConnection(): SystemConnection {
		if (!this.systemConnection)
			throw new Error('no system connection is being used');
		return this.systemConnection;
	}

	private getSimDaysInMs() {
		const days = this.useSystemConnection().simulationSubtractionDays || 0;
		return parseInt(`${days}`) * 24 * 60 * 60 * 1000;
	}
	private getQueryLagInMs() {
		const minutes = this.useSystemConnection().queryLagMinutes || 0;
		return parseInt(`${minutes}`) * 60 * 1000;
	}

	private makeTimeRange(intervalSec: string | number) {
		const { sampleDurationSeconds, ...rest } = this.useSystemConnection();
		const queryLagMs = this.getQueryLagInMs();
		const simDaysInMs = this.getSimDaysInMs();
		const offsetMs = simDaysInMs + queryLagMs;
		const parsedIntervalSeconds = parseInt(`${intervalSec}`) || 0;
		const intervalRange =
			Math.max(parsedIntervalSeconds, sampleDurationSeconds) * 1000;
		return TimeRange.make({ ...rest, offsetMs, intervalRange });
	}

	protected peekQuery(
		req: SensorConfigFormShape,
		queryPrefix?: string,
		useInOperator = true,
	): string {
		const {
			sensorChannelField,
			sensorDateField,
			sensorIdField,
			tagValue,
			sensorId,
			sensorTable,
			collectionInterval,
		} = req;
		const range = this.makeTimeRange(collectionInterval);
		const sensorIdConditionValue = tagValue || sensorId;
		const tagCondition = useInOperator
			? `${sensorIdField} IN (${sensorIdConditionValue})`
			: `(${sensorIdField} = ${sensorIdConditionValue})`;
		const query = `SELECT
${sensorChannelField} AS value,
${sensorDateField} AS datetime,
${sensorIdField} AS tag
FROM ${sensorTable}
WHERE ${sensorDateField} >= ${range.start} AND ${sensorDateField} < ${range.end}
AND ${tagCondition}
ORDER BY ${sensorDateField} ASC`;
		return queryPrefix ? `${queryPrefix}\n${query}` : query;
	}

	public createQuery(form: SensorConfigFormShape): string {
		try {
			const { quoteFormat, tagFormat, queryPrefix, serverType } =
				this.useSystemConnection();
			const enclosed = PayloadPeekMethods.toEnclosed({
				data: form,
				quoteFormat,
				tagFormat,
			});
			let useInOperator = true;
			if (DbHelpers.isOfType('iHistorian', serverType || ''))
				useInOperator = false;
			return this.peekQuery(enclosed, queryPrefix || '', useInOperator);
		} catch (error) {
			return 'error';
		}
	}
}
